// encryption.service.ts
import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EncryptionService {
  encrypt(data: object, key: string): string {
    const jsonData = JSON.stringify(data);
    return CryptoJS.AES.encrypt(jsonData, key).toString();
  }

  decrypt(encrypted: string, key: string): object | null {
    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, key);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decrypted);
    } catch {
      return null; // Clave incorrecta o dato corrupto
    }
  }
}
